import { cn } from "~/utils/cn";

export default function RichText({
  field,
  className,
}: {
  field: string;
  className?: string;
}) {
  return (
    <div
      className={cn("rich-text", className)}
      dangerouslySetInnerHTML={{ __html: field }}
    ></div>
  );
}
